

(function($, App, Utils){
  'use strict';

  var logger = new Logger('DataHiRes');

  Utils.add('DataHiRes', {

    onResize: function() {
      $('*[data-hi-res]').not('[data-hi-res=""]').each(function(i, e) {
        var
          self = $(this),
          hiResGroup = self.data('hiRes'),
          hiResStrings = hiResGroup.split(','),
          width = self.width();

        for (var i = 0; i < hiResStrings.length; i++) {
          var
            string = hiResStrings[i],
            group = string.split('|'),
            trigger = group[0],
            img = group[1];

          if (width > trigger) {
            var bg = new Image();

            $(bg).on('load', function(e) {
              logger.info('Image loaded, setting bg to', img);
              self.css('background-image', 'url('+ img +')');
            }).attr('src', img);

          }
        }

      });
    },

    init: function() {
      this.onResize();
    }

  });

})(jQuery, window.App, window.App.Utils);
